import(/* webpackMode: "eager", webpackExports: ["DocsSearchView"] */ "/app/src/features/docs/components/search-view.tsx");
